import { Routes } from "@angular/router";

export const disabilitiesRoutes: Routes = [
  {
    path: "",
    title: "DASHBOARD.DISABILITIES",
    loadComponent: () => import("./pages/disabilities-list/disabilities-list.component").then((m) => m.DisabilitiesListComponent),
  },
];

export const disabilitiesManagementRoutes: Routes = [
  {
    path: "add",
    title: "DASHBOARD.ADD_DISABILITY",
    loadComponent: () => import("./pages/add-edit-disability/add-edit-disability.component").then((m) => m.AddEditDisabilityComponent),
  },
  {
    path: "edit/:id",
    title: "DASHBOARD.EDIT_DISABILITY",
    loadComponent: () => import("./pages/add-edit-disability/add-edit-disability.component").then((m) => m.AddEditDisabilityComponent),
  },
];
